import { moduleNames } from "@lib/appconst"
import fileService from "@services/common/fileService"
import { appDataStoreInstance as appDataStore } from "../appDataStore"

function toOptionalNumber(value: any): number | undefined {
  if (value === undefined || value === null || value === "") {
    return undefined
  }
  if (typeof value === "number" && Number.isFinite(value)) {
    return value
  }
  const n = Number(value)
  return Number.isFinite(n) ? n : undefined
}

/** Kinh/vĩ độ từ API có thể là string; form NumberInput cần number. */
function withProjectLatLngAsNumbers(data: any) {
  if (!data || typeof data !== "object") {
    return data
  }
  return {
    ...data,
    latitude: toOptionalNumber(data.latitude),
    longitude: toOptionalNumber(data.longitude),
  }
}
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import projectMasterService from "@services/master-data/projectMasterService"
import { action, makeAutoObservable, observable } from "mobx"

class ProjectMasterStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any
  @observable settingData!: any
  @observable townshipsForAdmin!: any
  //
  @observable projectAccountIsLoading!: boolean
  @observable projectAccountData!: any
  @observable projectAccountDetailData!: any

  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
    this.projectAccountData = []
    this.townshipsForAdmin = []
  }

  @action
  async createOrUpdate(body: any, files?: any) {
    this.isLoading = true
    const result = await projectMasterService
      .createOrUpdate(body)
      .finally(() => {
        this.isLoading = false
      })
    this.detailData = result
    const { uniqueId } = result
    if (files && files.length && uniqueId) {
      files.forEach(async (file) => {
        if (file.originFileObj !== undefined) {
          const fileUpload = file.originFileObj
          await fileService.upload(moduleNames.project, uniqueId, fileUpload)
        }
      })
    }
    appDataStore.getListProject()
  }

  @action
  async newMasterProject() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async active(id: number, isActive) {
    await projectMasterService.active(id, isActive)
    appDataStore.getListProject()
  }

  @action
  async get(id: number) {
    this.isLoading = true
    const result = await projectMasterService
      .get(id)
      .finally(() => (this.isLoading = false))
    this.detailData = withProjectLatLngAsNumbers(result)
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await projectMasterService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }

  @action async getListTownShip(params?: any) {
    this.townshipsForAdmin = await projectMasterService.GetListTownshipForAdmin(
      params
    )
  }

  @action
  async getProjectSetting(id: number) {
    const result = await projectMasterService.getProjectSetting(id)
    this.settingData = result
  }
  @action
  async createOrUpdateSettings(body: any) {
    await projectMasterService.createOrUpdateSettings(body)
  }

  // Project account
  @action
  async createOrUpdateProjectAccount(body: any, files?: any) {
    this.projectAccountIsLoading = true
    const result = await projectMasterService
      .createOrUpdateProjectAccount(body)
      .finally(() => {
        this.projectAccountIsLoading = false
      })
    this.projectAccountDetailData = result
  }

  @action
  async initProjectAccount() {
    this.projectAccountDetailData = {
      id: 0,
    }
  }

  @action
  async activeProjectAccount(id: number, isActive) {
    await projectMasterService.activeProjectAccount(id, isActive)
  }

  @action
  async getProjectAccount(id: number) {
    this.projectAccountIsLoading = true
    const result = await projectMasterService
      .getProjectAccount(id)
      .finally(() => (this.projectAccountIsLoading = false))
    this.projectAccountDetailData = result
  }

  @action
  async getAllProjectAccounts(params: any) {
    this.projectAccountIsLoading = true
    const result = await projectMasterService
      .getAllProjectAccount(params)
      .finally(() => (this.projectAccountIsLoading = false))
    this.projectAccountData = result
  }
  @action
  async exportExcel(params: any, name?: string) {
    this.isLoading = true
    return await projectMasterService
      .exportExcel(params, name)
      .finally(() => (this.isLoading = false))
  }
  @action
  public import = async (file: File) => {
    this.isLoading = true
    try {
      const result = await projectMasterService
        .importProject(file)
        .finally(() => (this.isLoading = false))

      appDataStore.getListProject()
      return result
    } catch (error) {
      this.isLoading = false
      throw error
    }
  }
}

export default ProjectMasterStore
